var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-boost"},[(_vm.proposition)?_c('ExtraVisibility',{staticStyle:{"margin-top":"10px"},attrs:{"proposition":_vm.proposition}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }